module.exports = new __parcel__URL__("code-agents-tab-skeleton.tpl.874ad579.svg").toString();